import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const AssetItemSchema = buildEntrySchemaFor('assetItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      heading: RichTextSchema,
      description: RichTextSchema,
      asset: AssetSchema,
    }),
  ),
})
export type AssetItem = z.infer<typeof AssetItemSchema>
